import Vue from 'vue';
import router from './router';
import App from './App.vue';
import moment from 'moment';
import IdleVue from 'idle-vue';
import jwt_decode from 'jwt-decode';
import axios from 'axios';
import { apiServerUrl } from './config/config.json';

import vuetify from './plugins/vuetify';
import store from './store';
import auth from './store/modules/auth';
import VuePapaParse from 'vue-papa-parse';

import VueDOMPurifyHTML from 'vue-dompurify-html';
import Print from 'vue-print-nb';
import VueQrcode from '@chenfengyuan/vue-qrcode';

//CSS Modules
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import './assets/css/index.css';
// Module Vue Init
Vue.use(Print);
Vue.use(VuePapaParse);
Vue.use(VueDOMPurifyHTML);
Vue.component(VueQrcode.name, VueQrcode);

Vue.config.productionTip = false;
Vue.prototype.moment = moment;

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 600000,
});

const refreshToken = async () => {
  const url = `${apiServerUrl}/login`;
  return new Promise((resolve) => {
    axios
      .post(url, {
        email: process.env.VUE_APP_ADMIN_EMAIL,
        password: process.env.VUE_APP_ADMIN_PASSWORD
      })
      .then((response) => {
        let { token, bypassKey } = response.data;
        localStorage.setItem('access_token', token);
        localStorage.setItem('bypass_key', bypassKey);
        resolve()
      })
  });
};
const VerifyTokenExpiration = () => {
  if (localStorage.getItem('access_token')) {
    const data = jwt_decode(localStorage.getItem('access_token') || '');
    const expirationDate = new Date(data.exp * 1000);
    return (
      expirationDate < new Date(moment().format('ddd MMM D YYYY HH:mm:ss'))
    );
  } else return false;
};
router.beforeEach(async (to, from, next) => {
  let isExpired = VerifyTokenExpiration();
  console.log(isExpired);
  if (isExpired) {
    await refreshToken()
    location.reload();
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!auth.getters.loggedIn()) {
      next({
        name: 'login',
      });
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.requiresVisitor)) {
    if (auth.getters.loggedIn()) {
      next({
        name: 'routes',
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
